import React from 'react';
import cx from 'classnames';

import { PropTypes } from 'helpers/react';
const { children, bool, string } = PropTypes;

import styles from './styles/index.scss';

export default class FullScreenDialog extends React.Component {
  static propTypes = {
    children,
    open: bool,
    className: string
  };
  static defaultProps = {};

  render() {
    const containerClasses = cx(
      styles['dialog'],
      this.props.open && styles['dialog--is-open'],
      this.props.className
    );

    return (
      <div className={containerClasses}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/FullScreenDialog/index.js